'use client';

import React, { createContext, useContext, useEffect, useLayoutEffect } from 'react';

const DocsThemeContext = createContext<{ toggle: () => void }>({ toggle: () => {} });
export const useDocsTheme = () => useContext(DocsThemeContext);

const initScript = `try{var t=localStorage.getItem('docs-theme');if(t==='dark')document.getElementById('docs-theme-root').setAttribute('data-docs-theme','dark')}catch(e){}`;

const useIsomorphicLayoutEffect = typeof window !== 'undefined' ? useLayoutEffect : useEffect;

export function DocsThemeProvider({ children }: { children: React.ReactNode }) {
  // Covers client-side navigation: script doesn't run, but this fires before first paint
  useIsomorphicLayoutEffect(() => {
    try {
      const stored = localStorage.getItem('docs-theme');
      if (stored === 'dark') {document.getElementById('docs-theme-root')?.setAttribute('data-docs-theme', 'dark');}
    } catch {
      // no-op
    }
  }, []);

  const toggle = () => {
    const root = document.getElementById('docs-theme-root');
    if (!root) {return;}
    const next = root.getAttribute('data-docs-theme') === 'dark' ? 'light' : 'dark';
    root.setAttribute('data-docs-theme', next);
    try { localStorage.setItem('docs-theme', next); } catch {
      // no-op
    }
  };

  return (
    <DocsThemeContext.Provider value={{ toggle }}>
      {/* suppressHydrationWarning covers the hard-refresh case where the script sets dark before React hydrates */}
      <div id="docs-theme-root" data-docs-theme="light" suppressHydrationWarning>
        <script dangerouslySetInnerHTML={{ __html: initScript }} />
        {children}
      </div>
    </DocsThemeContext.Provider>
  );
}
